<template>
  <div class="p-email-notification-settins-edit-form">
    <div class="p-email-notification-settins-edit-form__content">
      <email-notifications-settings-form
        ref="form"
        v-model="formValue"
      />
    </div>
    <div class="p-email-notification-settins-edit-form__footer">
      <el-button
        type="secondary"
        @click="handleCancelClick"
      >
        {{ $t('action.cancel') }}
      </el-button>
      <el-button
        native-type="submit"
        :loading="isEmailNotificationsSettingsEditing"
        @click="handleSaveClick"
      >
        {{ $t('action.save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setAutoFocus } from '@/app/library/setAutoFocus';
import EmailNotificationsSettingsForm from '@/app/components/consumer-profile/EmailNotificationsSettingsForm.vue';

export default {
  name: 'EmailNotificationsSettingsEditForm',
  components: {
    EmailNotificationsSettingsForm
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  emits: [
    'submit',
    'cancel'
  ],
  data() {
    return {
      formValue: {
        language: undefined,
        support: undefined,
        home: undefined
      }
    };
  },
  computed: {
    ...mapGetters('app', [
      'isEmailNotificationsSettingsEditing'
    ])
  },
  created() {
    this.formValue = {
      ...this.formValue,
      ...this.value
    };
  },
  async mounted() {
    await this.$nextTick();
    setAutoFocus(this.$el);
  },
  methods: {
    ...mapActions('app', [
      'editEmailNotificationsSettings'
    ]),
    async handleSaveClick() {
      const isFormValid = await this.$refs.form.validate();
      if (isFormValid) {
        await this.editEmailNotificationsSettings(this.formValue);
        this.$emit('submit');
      }
    },
    handleCancelClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.p-email-notification-settins-edit-form {
  padding-bottom: 16px;
  background-color: var(--av-fixed-white);

  &__footer {
    display: flex;
    justify-content: flex-end;
    padding-right: 24px;
  }
}
</style>
